import React from "react";
import "./ForgetPassword.scss";
import Image from "../../components/image/Image";
import { AppIcons } from "../../data/appIcons";
import ForgetPasswordForm from "../../features/forgetPassword/ForgetPasswordForm";

const ForgetPassword = () => {
  return (
    <div className="main-login-section">
      <div className="min-h-full flex items-center justify-center w-full login-wrapper">
        <div className="login-main-bg">
          <div>
            <Image
              imagePath={AppIcons.logoImage}
              imgCustomClassName="open-bar"
              altText="Icon"
            ></Image>
          </div>
          <div className="text-center mb-4">
            <h2 style={{ textAlign: "center", color: "#1e4620", fontSize: "26px", fontWeight: "600", margin: "25px 0 25px 0" }}>
              Reset Password
            </h2>
            {/* <p style={{ textAlign: "center", color: "#4b5563", fontSize: "14px", margin: "0 0 20px 0" }}>
              Enter the email to retrieve your account
            </p> */}
          </div>
          <div>
            <ForgetPasswordForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
